module.exports = __webpack_public_path__ + "img/KYC_check_ic_confirm.b8ae15d.svg";